import { operators as o } from '@pendo/aggregations';
import { DxSegment, DxSegmentConfig } from '@middleware/types';

const draftRegex = /^draft\d$/;
const isDraftSegment = (id: string) => draftRegex.test(id);

const findSegment = (segments?: DxSegmentConfig[]) => {
    return (segmentId: string): DxSegment | undefined => {
        if (!segments) return;

        return segments.find((segment) => segment?.value.id === segmentId)?.value;
    };
};

// generateAggregationSegment()
// Filters dataSource by segment
export default function generateAggregationSegment ({
    segmentId,
    segment,
    segments,
    includeIdentified = true,
    hasShowAnonymousFlag,
}: {
    segmentId: string;
    segment?: DxSegmentConfig;
    segments?: DxSegmentConfig[];
    includeIdentified?: boolean;
    hasShowAnonymousFlag: boolean;
}) {
    if (isDraftSegment(segmentId)) {
        const draftSegment: DxSegment | undefined = segment?.value || findSegment(segments)(segmentId);

        if (draftSegment?.pipeline) {
            return [o.segment({ pipeline: draftSegment.pipeline })];
        }
        if (draftSegment?.pipelines && draftSegment?.compound) {
            return [
                o.segment({
                    pipelines: draftSegment.pipelines,
                    compound: draftSegment.compound,
                }),
            ];
        }

        return [];
    }

    const segmentPipeline = [];
    switch (segmentId) {
        case 'everyone':
        case 'blacklistOnly':
            segmentPipeline.push(
                hasShowAnonymousFlag || !includeIdentified ? o.segment(null) : o.identified('visitorId'),
            );
            break;
        case 'everyoneExcludingAnonymous':
            if (includeIdentified) segmentPipeline.push(o.identified('visitorId'));
            break;
        case 'anonymousVisitorsOnly':
            if (includeIdentified) segmentPipeline.push(o.identified('!visitorId'));
            break;
        default: {
            if (!hasShowAnonymousFlag && includeIdentified) segmentPipeline.push(o.identified('visitorId'));
            if (segmentId) segmentPipeline.push(o.segment(segmentId));
        }
    }

    return segmentPipeline;
}
